<template>
  <div>
    <div
      class="ml-4 mr-4"
      :style="pathMixin_isMeeting ? 'max-width: 800px !important;' : ''"
    >
      <div class="is-flex is-justify-content-center filtersContainer">
        <!--  MOBILE FILTERS MODAL BOX -->
        <div ref="mainFilterButton" id="mainFilterButton">
          <ShowModalButton
            :rounded="true"
            :label="filterButtonLabel"
            :type="'is-info is-outlined'"
            :size="'is-small'"
            :icon-left="'filter-variant-plus'"
            :close-modal="closeCustomModal"
            :key="forceKey"
            data-test="modal_filters_button"
            class="air_filter_all_filters_btn air_filter_btn"
          >
            <template #modalContent>
              <div id="modalFilters">
                <h2 class="is-size-4 gant-text has-text-centered">
                  {{ filterButtonLabel }}
                </h2>
                <div class="is-flex is-justify-content-center pb-3">
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox()
                      resetFilters()
                    "
                  />
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox()
                      resetFilters()
                      forceClose_closeModal()
                    "
                    class="ml-3"
                    :label="'Reset and Close'"
                  />
                </div>
                <hr class="mt-1 mb-5" />
                <div class="is-flex is-justify-content-center mb-2">
                  <div ref="unusedTicketsOnly">
                    <b-button
                      v-if="unusedTickets.length > 0"
                      rounded
                      :type="
                        filters.unusedTicketsOnly ? 'is-info' : 'is-default'
                      "
                      size="is-small"
                      :icon-left="
                        filters.unusedTicketsOnly
                          ? 'checkbox-marked-outline'
                          : ''
                      "
                      @click="toggleShowUnusedTicketsOnly()"
                    >
                      Unused Tickets Only
                      <ResetFilterButton
                        v-if="filters.unusedTicketsOnly"
                        @reset="resetFilter('unusedTicketsOnly')"
                      />
                    </b-button>
                  </div>
                </div>

                <div class="columns" style="padding: 3%">
                  <!-- SORT BY -->
                  <div v-if="sortOptions.length > 0" class="column is-flex">
                    <FieldsetBox
                      :box-style="sortOrder ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            sortOrder
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Sort by</span
                        >
                      </template>
                      <template #content>
                        <SortButtons
                          :value="sortOrder"
                          :options="sortOptions"
                          @input="(order) => updateSortOrder(order)"
                        />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- AIRLINES -->
                  <div class="column is-flex">
                    <FieldsetBox
                      :box-style="
                        filters.selectedAirlines.length > 0
                          ? highlightedBoxStyle
                          : ''
                      "
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            filters.selectedAirlines.length > 0
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Airlines</span
                        >
                      </template>
                      <template #content>
                        <ChainSelection
                          data-test="modal_airlines_filter_list"
                          :selectedChains="filters.selectedAirlines"
                          :preferredVendors="preferredVendors"
                          :preferredOnly.sync="preferredOnly"
                          :availableChains="filterOptions.allAirlines"
                          :filteredChains="filterOptions.filteredAirlines"
                          @input="
                            (airlines) =>
                              updateValue('selectedAirlines', airlines)
                          "
                        />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- RATING -->
                  <div
                    v-if="filterOptions.highestRating"
                    class="column is-flex"
                  >
                    <FieldsetBox
                      :box-style="filters.minRating ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            filters.minRating
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Rating</span
                        >
                      </template>
                      <template #content>
                        <RatingSelectionRadioButtons
                          :value="filters.minRating"
                          :highestRating="filterOptions.highestRating"
                          @input="(rating) => updateValue('minRating', rating)"
                        />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- PRICE -->
                  <div v-if="filterOptions.priceData" class="column is-flex">
                    <FieldsetBox
                      :box-style="highlights.price ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            highlights.price
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Price</span
                        >
                      </template>
                      <template #content>
                        <b-field
                          :label="
                            'Price: ' + $helpers.getCurrencySymbol(config.currencyCode) +
                              filters.minPrice +
                              '-' + $helpers.getCurrencySymbol(config.currencyCode) +
                              filters.maxPrice
                          "
                          style="width: 180px"
                        >
                          <HistogramSliderW2
                            :value="priceRange"
                            :width="180"
                            :expo="false"
                            :height="25"
                            :sliderData="filterOptions.priceData"
                            @input="updatePrice"
                          ></HistogramSliderW2>
                        </b-field>
                      </template>
                    </FieldsetBox>
                  </div>
                </div>
                <div class="columns" style="padding: 3%">
                  <!-- POLICY -->
                  <div
                    v-if="filterOptions.availablePolicies"
                    class="column is-flex is-one-quarter"
                  >
                    <FieldsetBox
                      :box-style="filters.minPolicy ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            filters.minPolicy
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Policy</span
                        >
                      </template>
                      <template #content>
                        <PolicySelectionCheckboxes
                          :value="filters.minPolicy"
                          :availablePolicies="filterOptions.availablePolicies"
                          @input="(value) => updateValue('minPolicy', value)"
                        />
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- STOPS -->
                  <div v-if="showStops" class="column is-flex is-one-third">
                    <FieldsetBox
                      :box-style="highlights.stops ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            highlights.stops
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Stops</span
                        >
                      </template>
                      <template #content>
                        <div class="filterFlexContainer">
                          <div v-if="filterOptions.stops.length > 0">
                            <h5 class="is-size-7 is-uppercase">
                              <strong
                                >{{ filterOptions.stops[0].name }}
                              </strong>
                            </h5>
                            <div class="field">
                              <FlightStopsSelectionRadioBoxes
                                data-test="outbound_stops_filter_list"
                                :options="filterOptions.stops[0].options"
                                :value="filters.maxStopsSegment1"
                                @input="
                                  (stops) =>
                                    updateValue('maxStopsSegment1', stops)
                                "
                              ></FlightStopsSelectionRadioBoxes>
                            </div>
                          </div>
                          <div v-if="filterOptions.stops.length > 1" class="">
                            <h5 class="is-size-7 is-uppercase">
                              <strong
                                >{{ filterOptions.stops[1].name }}
                              </strong>
                            </h5>
                            <div class="field">
                              <FlightStopsSelectionRadioBoxes
                                data-test="outbound_stops_filter_list"
                                :options="filterOptions.stops[1].options"
                                :value="filters.maxStopsSegment1"
                                @input="
                                  (stops) =>
                                    updateValue('maxStopsSegment2', stops)
                                "
                              ></FlightStopsSelectionRadioBoxes>
                            </div>
                          </div>
                        </div>
                      </template>
                    </FieldsetBox>
                  </div>
                  <!-- TIMES -->
                  <div v-if="showTimes" class="column is-flex">
                    <FieldsetBox
                      :box-style="highlights.times ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            highlights.times
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >Times</span
                        >
                      </template>
                      <template #content>
                        <div class="filterFlexContainer">
                          <div>
                            <div class="">
                              <h5 class="is-size-7 is-uppercase">
                                <strong>Outbound Flight</strong>
                              </h5>
                              <div class="field">
                                <FlightTimeSelection
                                  :value="filters.timeRangeSegment1"
                                  @input="
                                    (timeRange) =>
                                      updateValue(
                                        'timeRangeSegment1',
                                        timeRange
                                      )
                                  "
                                />
                              </div>
                            </div>
                          </div>
                          <div v-if="filterOptions.times.length > 1">
                            <div class="">
                              <h5 class="is-size-7 is-uppercase">
                                <strong>Return Flight</strong>
                              </h5>
                              <div class="field">
                                <FlightTimeSelection
                                  :value="filters.timeRangeSegment2"
                                  @input="
                                    (timeRange) =>
                                      updateValue(
                                        'timeRangeSegment2',
                                        timeRange
                                      )
                                  "
                                ></FlightTimeSelection>
                              </div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </FieldsetBox>
                  </div>
                </div>
                <div class="columns" style="padding: 3%">
                  <!-- NDC Filters-->
                  <div
                    v-if="filterOptions.ndc"
                    class="column is-flex is-one-quarter"
                  >
                    <FieldsetBox
                      :box-style="filters.ndc ? highlightedBoxStyle : ''"
                    >
                      <template #header>
                        <span
                          class="textOnly"
                          :class="
                            filters.ndc
                              ? highlightedLabelClass
                              : 'has-text-grey-light'
                          "
                          >NDC Options</span
                        >
                      </template>
                      <template #content>
                        <b-radio
                          v-model="filters.ndc"
                          name="ndc"
                          type="is-teal"
                          size="is-small"
                          native-value="NDC Only"
                          @click.native="filters.ndc = 'NDC Only'"
                        >
                          NDC Only </b-radio
                        ><br />
                        <b-radio
                          v-model="filters.ndc"
                          name="ndc"
                          type="is-teal"
                          size="is-small"
                          native-value="Exclude NDC"
                          @click.native="filters.ndc = 'Exclude NDC'"
                        >
                          Exclude NDC </b-radio
                        ><br />
                        <b-radio
                          v-model="filters.ndc"
                          name="ndc"
                          type="is-teal"
                          size="is-small"
                          native-value="All"
                          @click.native="filters.ndc = 'All'"
                        >
                          All
                        </b-radio>
                      </template>
                    </FieldsetBox>
                  </div>
                </div>

                <div class="is-flex is-justify-content-center pt-5">
                  <b-button
                    type="is-primary"
                    size="is-small"
                    label="Apply Filters"
                    @click="forceClose_closeModal"
                    class="mr-1"
                  >
                  </b-button>
                  <b-button
                    type="is-outlined"
                    size="is-small"
                    label="Close"
                    @click="forceClose_closeModal"
                    class="mr-1"
                  >
                  </b-button>
                </div>
                <div class="is-flex is-justify-content-center pb-3">
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox()
                      resetFilters()
                    "
                  />
                  <ResetAllFiltersButton
                    v-if="numOfFiltersUsed > 2"
                    @clicked="
                      forceClose_closeDropdownBox()
                      resetFilters()
                      forceClose_closeModal()
                    "
                    class="ml-3"
                    :label="'Reset and Close'"
                  />
                </div>
              </div>
            </template>
          </ShowModalButton>
        </div>

        <!--  DESKTOP FILTERS (Custom Dropdowns) -->
        <div
          class="flexedFilters sortingFiltersContainer scrollContent is-flex"
        >
          <!-- SORT BY -->
          <section v-if="sortOptions.length > 0">
            <div ref="sortOrder">
              <b-button
                data-test="sort_filter_button"
                rounded
                size="is-small"
                :icon-right="!sortOrder ? 'menu-down' : null"
                :type="sortOrder ? 'is-info is-light' : 'is-outlined'"
                class="air_filter_sort_btn air_filter_btn"
                @click="
                  $popper.togglePopper($refs.sortOrder, $refs.sortButtons)
                "
              >
                Sort by{{ sortOrder ? ":" : "" }}
                <span class="has-text-weight-bold">{{
                  getSortLabel(sortOrder)
                }}</span>
              </b-button>
            </div>
            <div ref="sortButtons" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Sort by"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <SortButtons
                :value="sortOrder"
                :options="sortOptions"
                @input="(order) => updateSortOrder(order)"
              />
            </div>
          </section>
          <!-- UNUSED TICKETS -->
          <div v-if="unusedTickets.length > 0" ref="unusedTicketsOnly">
            <b-button
              v-if="unusedTickets.length > 0"
              rounded
              :type="filters.unusedTicketsOnly ? 'is-info' : 'is-default'"
              size="is-small"
              class="air_filter_unused_tickets_only_btn air_filter_btn"
              :icon-left="
                filters.unusedTicketsOnly ? 'checkbox-marked-outline' : ''
              "
              @click="toggleShowUnusedTicketsOnly()"
            >
              Unused Tickets Only
              <ResetFilterButton
                v-if="filters.unusedTicketsOnly"
                @reset="resetFilter('unusedTicketsOnly')"
              />
            </b-button>
          </div>
          <!-- AIRLINES -->
          <section v-if="filterOptions.allAirlines">
            <div ref="selectedAirlines">
              <b-button
                data-test="airlines_filter_button"
                rounded
                size="is-small"
                class="air_filter_airlines_btn air_filter_btn"
                :icon-right="
                  !filters.selectedAirlines.length > 0 ? 'menu-down' : null
                "
                :type="
                  filters.selectedAirlines.length > 0
                    ? 'is-info is-light'
                    : 'is-outlined'
                "
                @click="
                  $popper.togglePopper(
                    $refs.selectedAirlines,
                    $refs.airlinesCBs
                  )
                "
              >
                <span v-if="filters.selectedAirlines.length > 0">
                  Airlines:
                  <span class="has-text-weight-bold">
                    {{
                      filters.selectedAirlines
                        .map((airline) => $helpers.airlineName(airline.code))
                        .join(", ")
                    }}
                  </span>
                </span>
                <span v-else>Airlines</span>
                <ResetFilterButton
                  v-if="filters.selectedAirlines.length > 0"
                  @reset="resetFilter('selectedAirlines')"
                />
              </b-button>
            </div>
            <div ref="airlinesCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Airlines"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <ChainSelection
                data-test="airlines_filter_list"
                :selectedChains="filters.selectedAirlines"
                :availableChains="filterOptions.allAirlines"
                :filteredChains="filterOptions.filteredAirlines"
                :preferredVendors="preferredVendors"
                :preferredOnly.sync="preferredOnly"
                @input="(airlines) => updateValue('selectedAirlines', airlines)"
              />
            </div>
          </section>
          <!-- POLICY -->
          <section v-if="filterOptions.availablePolicies">
            <div ref="minPolicy">
              <b-button
                data-test="policy_filter_button"
                rounded
                size="is-small"
                class="air_filter_policy_btn air_filter_btn"
                :icon-right="!filters.minPolicy ? 'menu-down' : null"
                :type="filters.minPolicy ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.minPolicy, $refs.policyCBs)"
              >
                Policy{{ filters.minPolicy ? ":" : "" }}
                <span class="has-text-weight-bold">{{
                  returnPolicyValues(filters.minPolicy)
                }}</span>
                <ResetFilterButton
                  v-if="filters.minPolicy"
                  @reset="resetFilter('minPolicy')"
                />
              </b-button>
            </div>
            <div ref="policyCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Min Policy"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <PolicySelectionCheckboxes
                :value="filters.minPolicy"
                :availablePolicies="filterOptions.availablePolicies"
                @input="(value) => updateValue('minPolicy', value)"
              />
            </div>
          </section>
          <!-- RATING -->
          <section v-if="filterOptions.highestRating">
            <div ref="minRating">
              <b-button
                data-test="rating_filter_button"
                rounded
                size="is-small"
                class="air_filter_rating_btn air_filter_btn"
                :icon-right="!filters.minRating ? 'menu-down' : null"
                :type="filters.minRating ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.minRating, $refs.ratingCBs)"
              >
                Rating{{ filters.minRating ? ":" : "" }}
                <span class="has-text-weight-bold" v-if="filters.minRating">{{
                  ratingLabel(filters.minRating)
                }}</span>
                <ResetFilterButton
                  v-if="filters.minRating"
                  @reset="resetFilter('minRating')"
                />
              </b-button>
            </div>
            <div ref="ratingCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Min Rating"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <RatingSelectionRadioButtons
                :value="filters.minRating"
                :highestRating="filterOptions.highestRating"
                @input="(rating) => updateValue('minRating', rating)"
              />
            </div>
          </section>
          <!-- PRICE -->
          <section v-if="filterOptions.priceData">
            <div ref="maxPrice">
              <b-button
                data-test="price_filter_button"
                rounded
                size="is-small"
                class="air_filter_price_btn air_filter_btn"
                :icon-right="!highlights.price ? 'menu-down' : null"
                :type="highlights.price ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.maxPrice, $refs.priceCBs)"
              >
                Price{{ highlights.price ? ":" : "" }}
                <span class="has-text-weight-bold" v-if="highlights.price">{{
                  `${$helpers.getCurrencySymbol(config.currencyCode)}${filters.minPrice} - ${$helpers.getCurrencySymbol(config.currencyCode)}${filters.maxPrice}`
                }}</span>
                <ResetFilterButton
                  v-if="highlights.price"
                  @reset="resetFilter('priceRange')"
                />
              </b-button>
            </div>
            <div ref="priceCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Price Range"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <div class="ml-3 mr-3">
                <b-field
                  :label="'Price: ' + $helpers.getCurrencySymbol(config.currencyCode) + lowestFare + '-' + $helpers.getCurrencySymbol(config.currencyCode) + highestFare"
                  style="width: 180px"
                >
                </b-field>
                <HistogramSliderW2
                  :value="priceRange"
                  :width="180"
                  :expo="false"
                  :height="25"
                  :sliderData="filterOptions.priceData"
                  :key="forceKey"
                  @input="updatePrice"
                ></HistogramSliderW2>
              </div>
            </div>
          </section>
          <!-- STOPS -->
          <section v-if="showStops">
            <div ref="flightStops">
              <b-button
                data-test="stops_filter_button"
                rounded
                size="is-small"
                class="air_filter_stops_btn air_filter_btn"
                :icon-right="!highlights.stops ? 'menu-down' : null"
                :type="highlights.stops ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.flightStops, $refs.stopsCBs)"
              >
                Stops{{ highlights.stops ? ":" : "" }}

                <span class="has-text-weight-bold" v-if="highlights.stops">
                  {{
                    stopsLabel(
                      filters.maxStopsSegment1,
                      filters.maxStopsSegment2
                    )
                  }}
                </span>
                <ResetFilterButton
                  v-if="highlights.stops"
                  @reset="
                    resetFilter('maxStopsSegment1')
                    resetFilter('maxStopsSegment2')
                  "
                />
              </b-button>
            </div>
            <div ref="stopsCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Stops"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <div class="filterFlexContainer">
                <div>
                  <h5 class="is-size-7 is-uppercase">
                    <strong>{{ filterOptions.stops[0].name }}</strong>
                  </h5>
                  <div class="field">
                    <FlightStopsSelectionRadioBoxes
                      data-test="outbound_stops_filter_list"
                      :options="filterOptions.stops[0].options"
                      :value="filters.maxStopsSegment1"
                      @input="(stops) => updateValue('maxStopsSegment1', stops)"
                    ></FlightStopsSelectionRadioBoxes>
                  </div>
                </div>
                <div v-if="filterOptions.stops.length > 1" class="">
                  <h5 class="is-size-7 is-uppercase">
                    <strong> {{ filterOptions.stops[1].name }} </strong>
                  </h5>
                  <div class="field">
                    <FlightStopsSelectionRadioBoxes
                      data-test="return_stops_filter_list"
                      :options="filterOptions.stops[1].options"
                      :value="filters.maxStopsSegment2"
                      @input="(stops) => updateValue('maxStopsSegment2', stops)"
                    ></FlightStopsSelectionRadioBoxes>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <!-- TIMES -->
          <section v-if="showTimes">
            <div ref="flightTimes">
              <b-button
                rounded
                size="is-small"
                class="air_filter_flight_times_btn air_filter_btn"
                :icon-right="!highlights.times ? 'menu-down' : null"
                :type="highlights.times ? 'is-info is-light' : 'is-outlined'"
                @click="$popper.togglePopper($refs.flightTimes, $refs.timesCBs)"
              >
                <span v-if="!highlights.times">Times</span>
                <span v-else>
                  Times:
                  <span class="has-text-weight-bold">
                    {{
                      returnFlightTimesValues(
                        filters.timeRangeSegment1,
                        filters.timeRangeSegment2
                      )
                    }}
                  </span>
                </span>
                <ResetFilterButton
                  v-if="highlights.times"
                  @reset="
                    resetFilter('timeRangeSegment1')
                    resetFilter('timeRangeSegment2')
                  "
                />
              </b-button>
            </div>
            <div ref="timesCBs" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="Times"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <div class="filterFlexContainer">
                <div>
                  <div class="">
                    <h5 class="is-size-7 is-uppercase">
                      <strong>Outbound</strong>
                    </h5>
                    <div class="field">
                      <FlightTimeSelection
                        :value="filters.timeRangeSegment1"
                        @input="
                          (timeRange) =>
                            updateValue('timeRangeSegment1', timeRange)
                        "
                      ></FlightTimeSelection>
                    </div>
                  </div>
                </div>
                <div v-if="filterOptions.times.length > 1">
                  <div class="">
                    <h5 class="is-size-7 is-uppercase">
                      <strong>Return</strong>
                    </h5>
                    <div class="field">
                      <FlightTimeSelection
                        :value="filters.timeRangeSegment2"
                        @input="
                          (timeRange) =>
                            updateValue('timeRangeSegment2', timeRange)
                        "
                      ></FlightTimeSelection>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section>
            <div v-if="filterOptions.ndc" ref="ndcFilterButton">
              <b-button
                rounded
                size="is-small"
                data-test="ndc_filter_button"
                class="air_filter_ndc_btn air_filter_btn"
                :icon-right="!highlights.ndc ? 'menu-down' : ''"
                :type="highlights.ndc ? 'is-info is-light' : 'is-outlined'"
                @click="
                  $popper.togglePopper(
                    $refs.ndcFilterButton,
                    $refs.ndcDropdownMenu
                  )
                "
              >
                <span v-if="!highlights.ndc">
                  NDC
                </span>
                <span v-else>
                  NDC:
                  <span class="has-text-weight-bold">{{ filters.ndc }}</span>
                </span>
                <ResetFilterButton
                  v-if="highlights.ndc"
                  @reset="resetFilter('ndc')"
                />
              </b-button>
            </div>
            <div ref="ndcDropdownMenu" class="filterBox popper-popup">
              <FilterBoxHeader
                filter-name="ndc"
                @closeFilterBox="forceClose_closeDropdownBox"
              />
              <b-radio
                v-model="filters.ndc"
                name="ndc"
                type="is-teal"
                size="is-small"
                native-value="NDC Only"
                @click.native="(val) => updateValue('ndc', 'NDC Only')"
              >
                NDC Only </b-radio
              ><br />
              <b-radio
                v-model="filters.ndc"
                name="ndc"
                type="is-teal"
                size="is-small"
                native-value="Exclude NDC"
                @click.native="(val) => updateValue('ndc', 'Exclude NDC')"
              >
                Exclude NDC </b-radio
              ><br />
              <b-radio
                v-model="filters.ndc"
                name="ndc"
                type="is-teal"
                size="is-small"
                native-value="All"
                @click.native="(val) => updateValue('ndc', 'All')"
              >
                All
              </b-radio>
            </div>
          </section>
        </div>
      </div>
    </div>
    <ResetAllFiltersButton
      v-if="numOfFiltersUsed > 2"
      @clicked="
        forceClose_closeDropdownBox()
        resetFilters()
      "
    />
  </div>
</template>

<script>
import bookingMixin from "../../mixins/bookingMixin"
import ChainSelection from "./ChainSelection.vue"
import SortButtons from "./SortButtons.vue"
import PolicySelectionCheckboxes from "./PolicySelectionCheckboxes.vue"
import RatingSelectionRadioButtons from "./RatingSelectionRadioButtons"
import FlightStopsSelectionRadioBoxes from "./FlightStopsSelectionRadioBoxes.vue"
import FlightTimeSelection from "./FlightTimeSelection.vue"
import HistogramSliderW2 from "../HistogramSlider/HistogramSliderW2.vue"
import ShowModalButton from "../UI/ShowModalButton"
import ResetFilterButton from "./ResetFilterButton"
import FieldsetBox from "../UI/FieldsetBox"
import ResetAllFiltersButton from "./ResetAllFiltersButton"
import FilterBoxHeader from "./FilterBoxHeader"
import { filter } from "underscore"

export default {
  name: "FlightFilters",
  mixins: [],
  components: {
    ChainSelection,
    SortButtons,
    HistogramSliderW2,
    PolicySelectionCheckboxes,
    RatingSelectionRadioButtons,
    FlightStopsSelectionRadioBoxes,
    FlightTimeSelection,
    ShowModalButton,
    ResetFilterButton,
    FieldsetBox,
    ResetAllFiltersButton,
    FilterBoxHeader,
  },
  data() {
    return {
      showUnusedTicketsOnly: false,
      preferredOnly: false,
      highlightedBoxStyle: "border: 1px solid hsl(204, 86%, 60%);",
      highlightedLabelClass: "has-text-info has-text-weight-bold",
      defaultFilters: {
        minPrice: 0,
        maxPrice: 1000,
        selectedAirlines: [],
        minRating: 0,
        maxStopsSegment1: "",
        maxStopsSegment2: "",
        timeRangeSegment1: { range: [0, 24], segment: 0 },
        timeRangeSegment2: { range: [0, 24], segment: 0 },
        minPolicy: [],
        ndc: "All",
        unusedTicketsOnly: false,
      },
    }
  },
  props: {
    config: {
      type: Object,
      required: true,
      validator(value) {
        return [
          "filterOptions",
          "preferredVendors",
          "sortOptions",
          "sortOrder",
          "unusedTickets",
          "tripVal",
        ].every((key) => key in value)
      },
    },
  },
  computed: {
    filterOptions() {
      return this.config.filterOptions
    },
    preferredVendors() {
      return this.config.preferredVendors
    },
    sortOptions() {
      return this.config.sortOptions
    },
    unusedTickets() {
      return this.config.unusedTickets
    },

    tripVal() {
      return this.config.tripVal
    },
    sortOrder() {
      return this.config.sortOrder
    },
    filters: {
      get() {
        return this.$store.state.flight.filters
      },
      set(value) {
        this.$store.commit("flight/SET_FILTERS", value)
      },
    },
    filterButtonLabel() {
      let label = "All Filters"
      if (this.numOfFiltersUsed > 0) {
        label += ` (${this.numOfFiltersUsed})`
      }
      return label
    },
    priceRange() {
      return Array(this.filters.minPrice, this.filters.maxPrice)
    },
    lowestFare() {
      return this.filterOptions.priceData ? this.filterOptions.priceData[0] : 0
    },
    highestFare() {
      return this.filterOptions.priceData
        ? this.filterOptions.priceData[this.filterOptions.priceData.length - 1]
        : 0
    },
    //show blue highlights whenever filter value has changed from default value
    highlights() {
      return {
        sorting: false,
        airline: this.filters.selectedAirlines > 0 || false,
        policy:
          this.filters.minPolicy !== this.defaultFilters.minPolicy || false,
        rating:
          this.filters.minRating !== this.defaultFilters.minRating || false,
        times: this.highlightTimes || false,
        stops:
          this.filters.maxStopsSegment1 !==
            this.defaultFilters.maxStopsSegment1 ||
          this.filters.maxStopsSegment2 !==
            this.defaultFilters.maxStopsSegment2 ||
          false,
        price: true,
        unusedTickets:
          this.filters.unusedTicketsOnly !==
            this.defaultFilters.unusedTicketsOnly || false,
        ndc: this.filters.ndc !== "",
      }
    },
    highlightTimes() {
      return this.filters.timeRangeSegment1.range[0] !== 0 ||
        this.filters.timeRangeSegment1.range[1] !== 24 ||
        this.filters.timeRangeSegment2.range[0] !== 0 ||
        this.filters.timeRangeSegment2.range[1] !== 24
        ? true
        : false
    },
    highlightPrice() {
      return this.lowestFare !== this.filters.minPrice ||
        this.highestFare !== this.filters.maxPrice
        ? true
        : false
    },
    numOfFiltersUsed() {
      let num = 0
      for (let highlight in this.highlights) {
        if (this.highlights[highlight] === true) {
          num++
        }
      }
      return num
    },
    showTimes() {
      return this.filterOptions?.times?.length > 0
    },
    showStops() {
      return this.filterOptions?.stops?.length > 0
    },
    loading: {
      get() {
        return this.$store.state.bookTravel.searchLoadingStatus
      },
      set(value) {
        this.$store.commit("bookTravel/FLIGHT_SEARCH_LOADING_STATUS", value)
      },
    },
  },
  methods: {
    updateValue(key, value) {
      //console.log(`updateValue (component): `, key, value)
      const newFilters = { ...this.filters, [key]: value }
      this.filters = newFilters
      this.onFilterChange(newFilters)
    },
    updatePrice(range) {
      if (
        this.filters.minPrice != range[0] ||
        this.filters.maxPrice != range[1]
      ) {
        //console.log(`updatePrice: `, range)
        const newFilters = {
          ...this.filters,
          minPrice: range[0],
          maxPrice: range[1],
        }
        this.filters = newFilters
        //this.$emit("input", newFilters)
        this.onFilterChange(newFilters)
      }
    },
    updateSortOrder(sortOrder) {
      //console.log(`updateSortOrder: `, sortOrder)
      this.loading = true
      this.$emit("updateSort", sortOrder)
      setTimeout(() => {
        this.loading = false
      }, 100)
    },
    toggleShowUnusedTicketsOnly() {
      const newFilters = { ...this.filters }
      newFilters.unusedTicketsOnly = !this.filters.unusedTicketsOnly
      newFilters.unusedTicketAirlines = this.unusedTickets
      this.filters = newFilters
      this.onFilterChange(newFilters)
      this.forceClose_closeDropdownBox()
    },
    restoreDefaults(showRestoreMessage = true) {
      if (showRestoreMessage) {
        this.$buefy.toast.open({
          message: "Please wait while we're restoring defaults",
          type: "is-info",
        })
      }

      //reset each filter to default value
      let names = Object.keys(this.filters)
      names.forEach((name) => {
        this.filters[name] = this.defaultFilters[name]
      })

      this.filters.minPrice = this.minPrice
      this.filters.maxPrice = this.maxPrice
    },
    getSortLabel(val) {
      let option = this.sortOptions.find((option) => {
        return option.value == val
      })

      if (option) {
        return option.label
      } else {
        return val
      }
    },
    //reset a specific filter to default value
    resetFilter(value) {
      //console.log("resetFilter: filterType", value)
      this.forceKey_forceKeyChange()
      this.forceClose_closeDropdownBox()
      switch (value) {
        case "sortOrder":
        case "minPolicy":
        case "minRating":
        case "maxStopsSegment1":
        case "maxStopsSegment2":
          this.filters[value] = ""
          break
        case "unusedTicketsOnly":
          this.filters.unusedTicketsOnly = false
          break
        case "selectedAirlines":
          //console.log("reset selectedAirlines")
          this.filters.selectedAirlines = []
          break
        case "priceRange":
          this.filters.minPrice = this.lowestFare
          this.filters.maxPrice = this.highestFare
          break
        case "timeRangeSegment1":
          this.filters.timeRangeSegment1 = { segment: 0, range: [0, 24] }
          break
        case "timeRangeSegment2":
          var tempSegment2 = this.tripVal === 1 ? [0, 24] : ["", ""]
          this.filters.timeRangeSegment2 = { segment: 0, range: tempSegment2 }
          break
        case "ndc":
          this.filters.ndc = ""
          break
        default:
          this.$store.commit("flight/RESET_FILTERS")
      }
      const newFilters = { ...this.filters }
      this.onFilterChange(newFilters)
    },
    //reset all filters to default values
    resetFilters() {
      this.$store.commit("flight/RESET_FILTERS")
      const newFilters = { ...this.filters }
      this.onFilterChange(newFilters)
      //this.$emit("input", this.filters)
    },
    ratingLabel(val) {
      let rating

      switch (val) {
        case 50:
          rating = "5+"
          break
        case 60:
          rating = "6+"
          break
        case 70:
          rating = "7+"
          break
        case 80:
          rating = "8+"
          break
        case 90:
          rating = "9+"
          break
        default:
          rating = "Any"
      }

      return rating
    },
    stopsLabel(stop1, stop2) {
      let stop1Value
      let stop2Value

      switch (stop1) {
        case 0:
          stop1Value = "Non-stop"
          break
        case 1:
          stop1Value = "1 stop or less"
          break
        case 2:
          stop1Value = "2 stops or less"
          break
        default:
        //
      }

      switch (stop2) {
        case 0:
          stop2Value = "Non-stop"
          break
        case 1:
          stop2Value = "1 stop or less"
          break
        case 2:
          stop2Value = "2 stops or less"
          break
        default:
        //
      }

      let flightStops = ""
      stop1Value ? (flightStops += `Outbound: ${stop1Value}`) : ""
      stop1Value && stop2Value ? (flightStops += ` / `) : ""
      stop2Value ? (flightStops += `Return: ${stop2Value}`) : ""

      return flightStops
    },
    returnFlightTimesValues(time1, time2) {
      let timesInfo = ""

      if (time1.range[0] > 0 || time1.range[1] < 24) {
        timesInfo += "OUTBOUND - "
        if (time1.segment === 0) {
          timesInfo += "Departure: "
        } else {
          timesInfo += "Arrival: "
        }
        timesInfo +=
          this.$helpers.miltTimeConvert(time1.range[0]) +
          " - " +
          this.$helpers.miltTimeConvert(time1.range[1])
      }

      if (this.tripVal > 0) {
        if (
          (time1.range[0] > 0 || time1.range[1] < 24) &&
          (time2.range[0] > 0 || time2.range[1] < 24)
        ) {
          timesInfo += " / "
        }
        if (time2.range[0] > 0 || time2.range[1] < 24) {
          timesInfo += "RETURN - "
          if (time2.segment === 0) {
            timesInfo += "Departure: "
          } else {
            timesInfo += "Arrival: "
          }
          timesInfo +=
            this.$helpers.miltTimeConvert(time2.range[0]) +
            " - " +
            this.$helpers.miltTimeConvert(time2.range[1])
        }
      }

      return timesInfo
    },
    returnPolicyValues(val) {
      let policy

      switch (val) {
        case 1:
          policy = "In Policy Only"
          break
        case 2:
          policy = "Manager Notifications"
          break
        case -1:
          policy = "Any"
          break
        default:
          policy = ""
      }

      return policy
    },
  },
  mounted() {
    //console.log(`mounted: `, this.filters)
  },
  inject: ["onFilterChange"],
}
</script>

<style lang="scss" scoped>
.dropdown + .dropdown {
  margin-left: 0 !important;
}
.field {
  min-width: 130px;
}
</style>
